import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

export default function ProxyETFTooltipContent() {
  return (
    <PDSFlexBox flexDirection="column" gap={SIZE.s12} margin={SIZE.s8}>
      <PDSText color={COLOR.white} weight="semibold">
        Proxy ETF
      </PDSText>
      <PDSText color={COLOR.white}>
        A proxy ETF is being used for optimization purposes. Please see asset
        page for more details.
      </PDSText>
    </PDSFlexBox>
  )
}
